import StoreAction from "../../../../constants/store-action";
import { validateEmail } from "../../../../utils/validation";
const createEmailField = (store, isValid, setIsValid) => {
    const value = store.data.customer.email;
    const update = (newValue) => store.dispatchStoreAction(StoreAction.UPDATE_NAMED_VALUE, {
        type: "customer",
        name: "email",
        value: newValue,
    });
    const validate = () => {
        const isValid = validateEmail(value);
        setIsValid(isValid);
    };
    const field = {
        value,
        displayError: !isValid,
        onChange: update,
        onFinish: validate,
    };
    return field;
};
export default createEmailField;
